module.exports = __webpack_public_path__ + "static/landing_mobile_bg-cb3fede7843a8e271aaae054b22885e5.svg";